export const scrollTo = {
  methods: {
    ScrollTo(element, event = null) {
      event?.preventDefault();

      const el = document.querySelector(`#${element}`);

      if (el) {
        const width = window.innerWidth;
        const elementPosition = el.getBoundingClientRect().top;

        const header = document.querySelector('.header');
        const topBarHeight = header.querySelector('.header__top').offsetHeight;
        const headerHeight = header.querySelector('.header__main').offsetHeight;
        const elAnchors = document.querySelector('.anchors');

        let heightAnchor = 0
        let headerOffset = headerHeight
        let margin = 32

        if (elAnchors && (event.target.offsetParent.classList.contains('anchors__slide') || event.target.offsetParent.getBoundingClientRect().top < elementPosition)) {
          heightAnchor = elAnchors.offsetHeight
        }

        if (width > 768){
          if (elementPosition + window.scrollY < window.pageYOffset) {
            headerOffset = topBarHeight + headerHeight;
          }

          if (width <= 1280) {
            headerOffset = headerOffset * (width / 1280);
          }
        }

        const offsetPosition = elementPosition + window.pageYOffset - headerOffset - heightAnchor - margin;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }
}
